import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable, Subject, Subscription, interval } from "rxjs";

import { BfxDialogData } from "./models/bfx-dialog-data.model";

import { BfxDialogBaseComponent } from "./bfx-dialog-base.component";

import { TableDefinition } from "shared/cubiq-services";
import { GoldenLayoutService } from "../golden-layout/golden-layout-service";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { map, take } from "rxjs/operators";

@Component({
  selector: `bfx-dialog-restart`,
  templateUrl: `./html/bfx-dialog-restart.html`,
  standalone: false,
})
export class BfxDialogRestartComponent extends BfxDialogBaseComponent {
  public title: string = "";
  public messages: Array<string> = [];
  public tableDefinition: TableDefinition = null;
  public subMessage: string = null;
  public restartLabel: string;
  public ignoreLabel: string;

  public restart: boolean = false;
  public countdown: number = 10;
  private countdownSubscription: Subscription = null;

  public data: any = {
    dialogId: null,
    dialogEventSubject: new Subject<BfxDialogData>(),
    actionEvent: null,
    payload: null,
    dialogData: {
      show: false,
      width: 450,
      count: 0,
    },
  };

  constructor(
    protected layoutService: GoldenLayoutService,
    protected translationService: TranslateService,
  ) {
    super();

    this.restartLabel = this.translationService.instant(
      "system_message.dialog.button.restart.label",
    );

    this.ignoreLabel = this.translationService.instant("system_message.dialog.button.ignore.label");
  }

  public openDialog(_dialogData: BfxDialogData): Observable<any> {
    try {
      this.data.dialogId = _dialogData.dialogId;
      this.data.actionEvent = _dialogData.event;
      this.data.payload = _dialogData.payload;

      if (_dialogData.payload != null) {
        this.messages = _dialogData.payload.messages;
        this.title = _dialogData.payload.title;
        this.subMessage = _dialogData.payload.subMessage;
        this.countdown = _dialogData.payload.restartTimeout;
      }

      if (this.messages.length > 0) {
        this.title = this.translationService.instant(this.title);
        this.data.dialogData.show = true;
      }

      if (this.countdown > 0) {
        let countdown: number = this.countdown;
        this.countdownSubscription = interval(1000)
          .pipe(
            take(countdown),
            map((x) => countdown - x - 1),
          )
          .subscribe((value: number) => {
            this.countdown = value;
            if (this.countdown <= 0) {
              this.countdownSubscription.unsubscribe();
              if (this.restart === false) {
                this.actionRestart();
              }
            }
          });
      }
    } catch (ex) {
      logger.out.error("ERROR: BfxDialogRestartComponent.openDialog(): Dialog exception! msg:", ex);
    }

    return this.data.dialogEventSubject.asObservable();
  }

  public closeDialog(): void {
    if (this.data.payload.callbackNegative && !this.restart) {
      this.data.payload.callbackNegative(this.data.actionEvent);
    }

    this.data.dialogData.title_text = null;
    this.data.dialogData.message_text = null;
    this.data.dialogData.message_text_ids = null;
    this.data.actionEvent = null;
    this.data.payload = null;
    this.data.dialogData.show = false;

    // inform dialog service that dialog is closed and to cleanup
    this.notifyDialogClosed(this.data.dialogEventSubject, this.data.dialogId);
  }

  public actionRestart(): void {
    this.restart = true;
    this.data.payload.callback(this.data.actionEvent);
    this.closeDialog();
  }
}
